import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import classNames from 'classnames';

import FA from 'utils/FA';
import './styles/ReadingProgressCell.scss';

const ReadingProgressCell = ({ className, value, status }) => {
  const completeReaders = status.filter(s => s.complete).map(s => s.reader);
  const incompleteReaders = status.filter(s => !s.complete).map(s => s.reader);
  const completed = completeReaders.length === status.length;

  const popover = (
    <Popover>
      <Popover.Header as='h3'>Review Status</Popover.Header>
      <Popover.Body>
        <div className='review-reading-progress-cell__popup-header'>Complete</div>
        {completeReaders.length > 0 ? (
          completeReaders.map(reader => (
            <div className='review-reading-progress-cell__complete' key={reader}>{reader}</div>
          ))
        ) : <div>None</div>}
        <div className='review-reading-progress-cell__popup-header'>Incomplete</div>
        {incompleteReaders.length > 0 ? (
          incompleteReaders.map(reader => (
            <div className='review-reading-progress-cell__incomplete' key={reader}>{reader}</div>
          ))
        ) : <div>None</div>}
      </Popover.Body>
    </Popover>
  );

  return (
    <OverlayTrigger placement='top' overlay={popover}>
      <td className={classNames(className, 'review-reading-progress-cell')}>
        {completed ? (
          <FA className='review-readers-complete' icon={faCheck} />
        ) : <div>{value}</div>}
      </td>
    </OverlayTrigger>
  );
};

ReadingProgressCell.propTypes = {
  /** className prop */
  className: PropTypes.string,

  /** Contacts Reading Progress Value */
  value: PropTypes.string,

  /** Contact Reading Status */
  status: PropTypes.arrayOf(
    PropTypes.shape({
      reader: PropTypes.string,
      complete: PropTypes.bool
    })
  )
};

ReadingProgressCell.defaultProps = {
  className: '',
  value: '',
  status: []
};

export default ReadingProgressCell;
